const BASE = "https://customer-assets-0z36b82j.emergentagent.net/job_fabc9f2a-640c-454c-9f3c-bf17a8f060db/artifacts";

export const IMAGES = {
    water: `${BASE}/57hdfu5n_IMG_7872.jpeg`,
    poolFull: `${BASE}/3o9ngdcf_IMG_7871.jpeg`,
    vacuum: `${BASE}/d7g8znpg_IMG_7870.jpeg`,
    waterfall: `${BASE}/6m3661j6_IMG_7869.jpeg`,
    deepBlue: `${BASE}/po81onqb_IMG_7868.jpeg`,
};

export const CONTACT = {
    phoneDisplay: "0466 111 623",
    phoneHref: "tel:0466111623",
    email: "trev61391@gmail.com",
    area: "Central Coast, NSW",
};
